import * as React from 'react'
import type { SVGProps } from 'react'
import { type Ref, forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSelectionIndicator = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke='var(--ds-color-base-main)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={3}
      d='m5 11 3 4 7-10'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSelectionIndicator)
export default ForwardRef
